import React from 'react';

const Footer = () => {
  
    return (
        <div>
             <div>
     <p style={{ color: "white", textAlign: 'center', marginTop: "3%" }}>
     Copyright &copy;2022 <span style={{fontWeight: "bolder"}}>Ashik</span>. All Rights Reserved</p>
      </div>
        </div>
    );
};

export default Footer;